module.exports = __webpack_public_path__ + "static/media/machine-empty.379febb6.svg";